<template>
  <div class="order-center">
    <div class="container">
      <div class="status-list">
        <div
          class="status-item"
          v-for="(v, k) in status_list"
          :key="`s` + k"
          :class="{ active: form_data.status === k }"
          @click="change_status(k)"
        >
          {{ v.name }}
          <template v-if="v.count > 0 || true">({{ v.count }})</template>
        </div>
        <div class="search">
          <img
            src="../../assets/images/icon-search.png"
            alt=""
            class="icon-search"
          />
          <input
            type="text"
            placeholder="搜索订单号"
            v-model="form_data.keyword"
            class="input"
            @keyup.enter="search"
          />
        </div>
      </div>

      <template v-if="order_list.length > 0">
        <div class="list">
          <div class="item">
            <div class="th">
              <div class="info">订单信息</div>
              <div class="category">服装品类</div>
              <div class="price">打板预算</div>
              <div class="period">交付周期</div>
              <div class="status">状态</div>
              <div class="action">操作</div>
            </div>
          </div>
          <div
            class="item td"
            v-for="(v, k) in order_list"
            :key="`or` + k"
            @click="go2detail(v.uuid)"
          >
            <div class="title flex align-center">
              <span @click.stop="copyOrderNo(v.make_no)">订单号：{{ v.make_no }}</span>
              <img class="margin-left-10" @click.stop="copyOrderNo(v.make_no)" src="../../assets/images/patternMaker/ico_copy.png" style="width:14px;height:14px;"  />
              <div @click.stop="showChat(v)" class="flex align-center">
                <img class="margin-left-30" src="../../assets/images/patternMaker/ico_chat.png" style="width:22px;height:22px;"  />
                <span class="text-666 margin-left-10 text-13">联系客服</span>
              </div>

              <!-- <template>
                <img class="margin-left-30" src="../../assets/images/patternMaker/ico_time.png" style="width:14px;height:14px;"  />
                <span class="text-red margin-left-10 text-13">派单剩余处理时间:2小时28分(超时自动拒绝)</span>
              </template> -->

            </div>
            <div class="content td">
              <div class="info">
                <div
                  class="sub-info"
                >
                  <div class="left">
                    <img
                      :src="v.design_data.category.image | default_img"
                      alt=""
                      class="image"
                    />
                  </div>
                  <div class="right">
                    <div class="sub-name">
                      {{ v.task_title }}
                    </div>
                    <div class="sub-create-time">
                      下单时间：{{ v.ord.create_time }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="category">
                <div

                  class="sub-info"

                >
                  {{ v.design_data.category.product_category_name }}
                </div>
              </div>
              <div class="price">¥{{ v.settle_money }}/款</div>
              <div class="period">
                <div class="text-bold">1天内</div>
                <div class="text-999" v-if="v.status==2">{{v.timeout_time}}之前</div>
              </div>
              <div class="status" :class="oc(v)">
                {{ v.status_name }}
              </div>
              <div class="action">
                <div
                  class="btn btn-pay"
                  @click.stop="acceptOrder(v)"
                  v-if="v.status == 0"
                >
                  我要接单
                </div>
                 <div
                  v-if="v.status == 0"
                  class="btn btn-refuse"
                  @click.stop="refuseOrder(v)"
                >

                  拒绝接单
                </div>
                <div class="btn-customer" @click="go2detail(v.uuid)">
                  查看详情
                </div>
              </div>
            </div>
          </div>
        </div>
        <Page
          :current="page"
          :page-size="size"
          :total="total"
          @on-change="changePage"
          show-total
          style="margin-top: 20px"
          show-sizer
          @on-page-size-change="changeSize"
          :page-size-opts="[5, 10, 20]"
        ></Page>
      </template>
      <template v-else>
        <img
          src="../../assets/images/no-data.png"
          style="width: 300px; display: block; margin: 0 auto"
          alt=""
        />
      </template>

      <AcceptOrder ref="AcceptOrder" @confirm="getOrderList"></AcceptOrder>
      <RefuseOrder ref="RefuseOrder" @confirm="getOrderList"></RefuseOrder>
      <Chat ref="chat"></Chat>
    </div>
  </div>
</template>

<script>
import {
  GetOrderMakeCount,
  GetOrderMakeList,
  Profile
} from "@/api/index.js";
import axios from "axios";
import AcceptOrder from "./components/Accept";
import RefuseOrder from "./components/Refuse";

export default {
  name: "OrderCenter",
  components: {
    AcceptOrder,
    RefuseOrder
  },
  data() {
    return {
      size: 10,
      page: 1,
      total: -1,
      form_data: {
        keyword: "",
        status: "all",
      },
      status_list: {
        all: { name: "全部订单", value: "all", count: 0 },
        wait_reply: { name: "待接单", value: "wait_reply", count: 0 },
        wait_submit: { name: "待打版", value: "wait_submit", count: 0 },
        wait_factory_confirm: { name: "已打板", value: "wait_factory_confirm", count: 0 },
        wait_revise: { name: "版型修改", value: "wait_revise", count: 0 },
        complete: { name: "待结算", value: "complete", count: 0 },
        settled: { name: "已结算", value: "settled", count: 0 },
        rejected: { name: "已拒绝", value: "rejected", count: 0 },
        submit_timeout: { name: "提交超时", value: "submit_timeout", count: 0 },
        accept_timeout: { name: "接单超时", value: "accept_timeout", count: 0 },
      },
      order_list: [],


    };
  },
  watch: {
    "form_data.status": function (newVal, oldVal) {
      this.form_data.status = newVal;
      this.page = 1;
      this.getOrderList();
    },
  },
  computed: {
    avatar() {
      return this.profile.avatar || require("@/assets/images/avatar.png");
    },
  },
  mounted() {
    this.change_status("all");
    axios
      .all([this.getProfile(), this.getOrderList()])
      .then(axios.spread(() => {}));
  },
  methods: {
    acceptOrder(e) {
      this.$refs.AcceptOrder.showModal(e)
    },

    refuseOrder(e) {
      this.$refs.RefuseOrder.showModal(e)
    },
    showChat(v) {
      this.$refs.chat.showChat();
    },
    async copyOrderNo(order_no) {
      if (!order_no) return;
      await navigator.clipboard.writeText(order_no);
      this.$layer.msg("复制成功");
    },
    search() {
      this.getOrderList();
    },

    oc(v) {
      return [v.status_text];
    },
    go2detail(uuid) {
      this.$router.push({ name: "PatternMakerOrderDetail", query: { uuid } });
    },
    changePage(page) {
      this.page = page;
      this.getOrderList();
    },
    changeSize(size) {
      this.page = 1;
      this.size = size;
      this.getOrderList();
    },
    change_status(s) {
      this.form_data.status = s;
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getOrderList() {
      this.order_list = [];
      return GetOrderMakeList({ ...this.form_data, page: this.page, size: this.size })
        .then((response) => {
          this.order_list = response.data.list;
          this.total = response.data.total;
          return GetOrderMakeCount(this.form_data);
        })
        .then((response) => {
          for (let code in response.data) {
            this.status_list[code].count = response.data[code];
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-center {
  width: 100%;
  .container {
    padding: 0 70px 0 30px;
    background: white;

    .status-list {
      position: relative;
      padding: 30px 0;
      display: flex;
      align-content: center;
      .status-item {
        margin: 0 14px;
        width: 90px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        &.active {
          background: #fa3d5a;
          border-radius: 5px;
          color: white;
        }
        &:first-child {
          margin-left: 0;
        }
      }
      .search {
        position: absolute;
        top: 23px;
        right: 0;
        .icon-search {
          position: absolute;
          top: 15px;
          left: 20px;
          width: 20px;
          height: 20px;
        }
        .input {
          width: 260px;
          height: 50px;
          line-height: 50px;
          border-radius: 25px;
          padding-left: 50px;
          background: #f3f4f6;
          font-size: 14px;
          outline: none;
          border: none;
        }
      }
    }

    .list {
      padding: 10px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .item {
        width: 100%;
        margin: 5px 0;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #ebedf2;
        &:first-child {
          border: none;
        }
        cursor: pointer;
        color: #191a1c;
        overflow: hidden;
        .title {
          height: 52px;
          line-height: 52px;
          padding-left: 20px;
          color: #191a1c;
          background: #F6F7FA;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
        .th {
          display: flex;
          flex-wrap: nowrap;
          line-height: 52px;
          text-align: center;
          background: #f6f7fa;
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #e3e3e3;
          &:first-child {
            border: none;
          }
          color: #575859;
          font-size: 14px;
          overflow: hidden;
          .info {
            width: 530px;
          }
           .category {
            width: 200px;
          }
          .price {
            width: 200px;
          }
          .period {
            width: 200px;
          }
          .status {
            width: 200px;
          }
          .action {
            width: 200px;
          }
        }
        .content {
          display: flex;
          flex-wrap: nowrap;
          text-align: center;
          align-items: center;
          .info {
            width: 530px;

            .sub-info {
              display: flex;
              padding: 10px;
              .left {
                .image {
                  width: 96px;
                  height: 96px;
                  border-radius: 8px;
                  object-fit: cover;
                }
              }
              .right {
                text-align: left;
                padding: 10px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                 height: 96px;
                .sub-name {
                  width: 100%;
                  color: #333333;
                  font-size: 14px;
                  font-weight: bold;
                }
                .sub-create-time {
                  width: 100%;
                  font-weight: 400;
                  font-size: 13px;
                  color: #666666;
                  margin-top: 10px;
                }
              }
            }
          }
          .category {
            width: 200px;

          }
          .price {
            width: 200px;

            font-weight: 400;
            font-size: 14px;
            color: #FF5000;
          }
          .period {
            width: 200px;
            font-size: 14px;
          }
          .status {
            width: 200px;
            font-size: 14px;
            &.wait_reply {
              color: #FF5000;
            }
            &.wait_submit {
              color: #0D99FF;
            }
            &.wait_factory_confirm {
              color: #02C160;
            }
            &.wait_revise {
              color: #FF5000;
            }
            &.complete {
              color: #666666;
            }
            &.settled {
              color: #666666;
            }
            &.rejected,
            &.timeout,
            &.accept_timeout {
              color: #999999;
            }
            &.cancel {
              color: #999999;
            }
          }
          .action {
            width: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            row-gap: 10px;
            .btn {
              width: 126px;
              height: 30px;
              line-height: 30px;
              background: #FF5967;
              border-radius: 4px;
              font-size: 14px;
              color: #333333;
              text-align: center;
              &.btn-pay {
                background: #fa3d5a;
                color: white;
              }
               &.btn-refuse {
                background: #FFFFFF;
                border: 1px solid #E3E3E3;
              }
            }
            .btn-customer {
              color: #3c3c3c;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}


.customer {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 200px;
  cursor: pointer;
}


</style>
